module.exports = __webpack_public_path__ + "img/assign_signers.987d7e0e.svg";